import { AddonData } from 'types'

export const baseAddonData: AddonData[] = [
  {
    id: 'Addon1',
    title: 'Trauma Cover',
    subtitle: 'What does it include?',
    features: ['a', 'b', 'c'],
    price: 19.99,
    pricePeriod: 'month',
    includedProductIDs: ['ITEM_1'],
  },
  {
    id: 'Addon2',
    title: 'Life Cover',
    subtitle: 'What does it include?',
    features: ['a'],
    price: 29.99,
    pricePeriod: 'month',
  },
  {
    id: 'Addon3',
    title: 'Life Cover',
    subtitle: 'What does it include?',
    features: ['a', 'b'],
    price: 29.99,
    pricePeriod: 'month',
  },
]
